import { render, staticRenderFns } from "./CompanyMenuActions.vue?vue&type=template&id=ff359b5c&scoped=true&"
import script from "./CompanyMenuActions.vue?vue&type=script&lang=js&"
export * from "./CompanyMenuActions.vue?vue&type=script&lang=js&"
import style0 from "./CompanyMenuActions.vue?vue&type=style&index=0&id=ff359b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff359b5c",
  null
  
)

export default component.exports